import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  public languages: string[] = ['ar', 'en'];

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService
  ) {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang('ar');

    const lang = this.getSavedLanguage();

    this.translate.use(lang);
    this.saveLanguage(lang);
  }

  public setLanguage(lang: string) {
    const selectedLang = this.languages.includes(lang) ? lang : 'ar';

    this.translate.use(selectedLang);
    this.saveLanguage(selectedLang);
  }

  public getCurrentLanguage(): string {
    return this.getSavedLanguage();
  }

  private getSavedLanguage(): string {
    const cookieLang = this.cookieService.get('lang');
    const localLang = localStorage.getItem('lang');

    if (cookieLang && this.languages.includes(cookieLang)) {
      return cookieLang;
    }

    if (localLang && this.languages.includes(localLang)) {
      return localLang;
    }

    return 'ar';
  }

  private saveLanguage(lang: string) {
    this.cookieService.set('lang', lang, {
      path: '/',
      sameSite: 'Lax'
    });

    localStorage.setItem('lang', lang);
  }

}